// extracted by mini-css-extract-plugin
export default {"root":"s20PrS","link":"JQeWpV","outletLogo":"skCwpG","iconSpan":"lVwflg"};